"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var MediaDeviceInfoShim = /** @class */ (function () {
    function MediaDeviceInfoShim(options) {
        Object.defineProperties(this, {
            deviceId: { get: function () { return options.deviceId; } },
            groupId: { get: function () { return options.groupId; } },
            kind: { get: function () { return options.kind; } },
            label: { get: function () { return options.label; } },
        });
    }
    return MediaDeviceInfoShim;
}());
exports.default = MediaDeviceInfoShim;
